module.exports = __webpack_public_path__ + "static/media/zyman.554813cc.png";